"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAddonValue;
var BURN_IN_CAPTIONS = 'BURN_IN_CAPTIONS';
var SRT_CAPTIONS = 'SRT_CAPTIONS';
var CHROMA_KEY = 'CHROMA_KEY';

function getAddonValue(type, value) {
  if ([BURN_IN_CAPTIONS, SRT_CAPTIONS].includes(type)) {
    return "".concat(type, "_").concat(value);
  }

  if (CHROMA_KEY === type && value) {
    return CHROMA_KEY;
  }

  return value;
}